import React, { useState, useEffect } from 'react';
import projectImage from '../Image/Apps/cv/cv.jpg'; // Replace with actual image
import heaz from '../Image/Apps/HazeShop/1.png';
import hezad from '../Image/Apps/HeazAdmin/hazeadmin1.jpg';
import ideco from '../Image/Apps/IDECOMainWebsite/1.png';
import idecoscada from '../Image/Apps/IdecoScada/2.png';
import empserv from '../Image/Apps/IdecoEmpSerivce/empsev.jpg';
import cbmis from '../Image/Apps/CBMISAI/cmbis1.jpg';
import cbmispy from '../Image/Apps/py-Toolbox/pytool.jpg';
import tender from '../Image/Apps/IdedcoTender/1.png';
import admin from '../Image/Apps/IdecoAdmin/1.png';
import eleloss from '../Image/Apps/IdecoElectricalLoss/Screenshot 2024-10-11 221123.png';
import insmovm from '../Image/Apps/Idedcoinspectionsummary/inssum.jpeg'
const projects = [
  {
    title: "Haze Shop",
    description: "Haze Shop is a dynamic and versatile online platform that seamlessly combines the power of affiliate marketing with a comprehensive suite of e-Solution and service offerings. As a one-stop-shop for customers, Haze Shop provides a diverse range of products from affiliate partnerships and also caters to the specific needs of customers through its e-Solution services. Over the years, Haze Shop has expanded its portfolio, creating various web and mobile applications, as well as AI models, to cater to a wide range of user preferences and requirements.The platform is built using the robust and flexible ASP.NET MVC framework, ensuring a seamless and user-friendly experience",
    category: "web",
    techStack: ["Asp.net MVC", "ADO.NET", "Azure", "SQL"],
    link: "https://github.com/yourusername/ecommerce-platform",
    img: heaz // Add image path
  },
  {
    title: "Haze Shop Admin Panel",
    description: `
    Haze Admin is a powerful and efficient web application designed to serve as the centralized hub for managing and mentoring the Haze Shop website.
     Developed using the robust ASP.NET Razor framework, Haze Admin empowers administrators and managers with a comprehensive suite of tools to efficiently oversee the website's operations. From curating carefully selected affiliate products to monitoring website performance, 
    Haze Admin provides a seamless and intuitive platform for ensuring the success and growth of Haze Shop.
    `,
    category: "web",
    techStack: ["Asp.net MVC", "ADO.NET", "Azure", "SQL"],
    link: "https://github.com/yourusername/ecommerce-platform",
    img: hezad // Add image path
  },
  {
    title: "Irbid District Electricity Co. Ltd",
    description: `
    The Irbid District Electricity Co. Ltd (IDECO) proudly stands as a reputable and well-known local company in Jordan, dedicated to providing reliable electricity services to the region. With a strong commitment to modernization and customer-centric solutions, IDECO has developed a cutting-edge website that offers a multitude of eServices to enhance the overall customer experience. Leveraging the power of ASP.NET MVC technologies, the website delivers seamless and user-friendly functionalities, enabling customers to access a wide range of services conveniently from the comfort of their homes.
    `,
    category: "web",
    techStack: ["Asp.net MVC", "ADO.NET", "Azure", "SQL"],
    link: "https://github.com/yourusername/ecommerce-platform",
    img: ideco // Add image path
  },
  {
    title: "Irbid District Electricity SCADA Dashboard",
    description: `
The Irbid District Electricity SCADA Dashboard Web App is a cutting-edge and specialized platform designed exclusively for managing and controlling smart meters and street lighting within the IDECO domain in Jordan. Developed using ASP.NET MVC technologies, this dedicated web application provides authorized employees with comprehensive tools to monitor, control, and track smart meter readings and street lighting operations. The SCADA Dashboard Web App empowers IDECO to optimize energy consumption, enhance operational efficiency, and proactively respond to any issues that may arise with street lighting or smart meters.    `,
    category: "web",
    techStack: ["Asp.net MVC", "ADO.NET", "Azure", "SQL"],
    link: "https://github.com/yourusername/ecommerce-platform",
    img: idecoscada // Add image path
  },
  {
    title: "Irbid District Electricity Employees Services",
    description: `
Irbid District Electricity Employees Services is a comprehensive and user-centric web application designed to cater exclusively to the needs of employees within the Irbid District Electricity Company in Jordan. The platform, powered by ASP.NET MVC technologies, serves as an all-inclusive hub for various eServices, streamlining essential employee-related processes and enhancing overall efficiency and satisfaction. By providing a range of features, including leave and vacation requests, social events applications, complaints submission, salary tracking, and more, the application ensures that employees can easily access and manage vital services in an organized and user-friendly manner.  `,
  category: "web",
    techStack: ["Asp.net MVC", "ADO.NET", "Azure", "SQL"],
    link: "https://github.com/yourusername/ecommerce-platform",
    img: empserv // Add image path
  },
  {
    title: "CBMIS AI Toolbox",
    description: `
    CBMIS AI Toolbox is a powerful and user-friendly front-end AI library developed using Reactjs. It serves as an all-in-one solution for building and training machine-learning models across various domains, including image recognition, text analysis, and audio voice processing.
This versatile application caters to both educational purposes and researchers, providing them with a seamless platform to delve into the world of artificial intelligence and explore the potential of cutting-edge machine-learning methods.
    `,
    category: "ml",
    techStack: ["React Js", "TensorFlow", "ml5", "Gammacv"],
    link: "https://github.com/yourusername/image-recognition-ai",
    img: cbmis // Add image path
  },
  {
    title: "Portfolio Website",
    description: "This responsive portfolio website showcasing my work. Built with React and featuring a dark mode toggle.",
    category: "web",
    techStack: ["React", "CSS3", "JavaScript"],
    link: "https://github.com/yourusername/portfolio-website",
    img: projectImage // Add image path
  },
  {
    title: "Irbid District Electricity Tender Web App",
    description: `
    The Irbid District Electricity Tender Web App is a specialized web application designed to facilitate the efficient management of tenders within the Irbid District Electricity Company (IDECO) in Jordan. This dedicated platform, powered by ASP.NET MVC technologies, provides a seamless and centralized solution for adding, editing, and deleting tenders, as well as displaying all active tenders on the main IDECO website. With its user-friendly interface and robust functionalities, the Tender Web App streamlines the tendering process, ensuring transparency and effectiveness in handling tender-related activities.
    `,
    category: "web",
    techStack: ["Asp.net MVC", "ADO.NET", "Azure", "SQL"],
    link: "https://github.com/yourusername/portfolio-website",
    img: tender // Add image path
  },
  {
    title: "CBMIS AI Toolbox - py",
    description: `
    CBMIS AI Toolbox is a powerful and user-friendly AI library developed using Python. It serves as an all-in-one solution for building and training machine-learning models across various domains, including image recognition, text analysis, and audio voice processing.
This versatile application caters to both educational purposes and researchers, providing them with a seamless platform to delve into the world of artificial intelligence and explore the potential of cutting-edge machine-learning methods.
`,
    category: "ml",
    techStack: ["Python", "Tensorflow", "scikit-learn", "PyTorch"],
    link: "https://github.com/yourusername/nlp-tool",
    img: cbmispy // Add image path
  },


  {
    title: "Irbid District Electricity Admin Dashboard Web App",
    description: `
The Irbid District Electricity Admin Dashboard Web App is a powerful and centralized platform designed exclusively for managing and controlling all the services, news, and articles on the main IDECO website in Jordan. This dedicated web application, developed using ASP.NET MVC technologies, provides administrators with comprehensive tools to streamline website content management, ensuring that the IDECO website remains up-to-date, informative, and user-friendly. The Admin Dashboard Web App empowers administrators with the ability to efficiently control and curate website content, enhancing the overall user experience for visitors and customers.
    `,
    category: "web",
    techStack: ["Asp.net MVC", "ADO.NET", "Azure", "SQL"],
    link: "https://github.com/yourusername/portfolio-website",
    img: admin // Add image path
  },

  {
    title: "IDECO Electrical Losses Dashboard Websites ",
    description: `
    The IDECO Electrical Losses Dashboard Website provides an interactive platform for analyzing and monitoring electrical losses within the company. It delivers real-time data insights, helping to identify inefficiencies, track performance, and optimize energy usage. Designed for engineers and managers, the dashboard visualizes key metrics and trends, enabling informed decisions to reduce losses and improve operational efficiency.
    `,
    category: "web",
    techStack: ["Asp.net MVC", "ADO.NET", "Azure", "SQL"],
    link: "https://github.com/yourusername/portfolio-website",
    img: eleloss // Add image path
  },
  {
    title: "IDECO Inspection Movement Summary ",
    description: `
The IDECO Inspection Movement Summary mobile app provides a streamlined platform for summarizing inspection movements within the company. It offers real-time updates, tracking inspection activities and consolidating key information for easy access. Designed for field inspectors and management, the app enhances operational efficiency by organizing inspection data and delivering actionable insights for better decision-making.

    `,
    category: "mob",
    techStack: [ "Flutter"],
    link: "https://github.com/yourusername/portfolio-website",
    img: insmovm // Add image path
  },
];

function Projects() {
  const [filter, setFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const projectsPerPage = 3;

  useEffect(() => {
    const filtered = filter === 'all'
      ? projects
      : projects.filter(project => project.category === filter);
    setFilteredProjects(filtered);
    setCurrentPage(1);
  }, [filter]);

  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <section id="projects" className="section">
      <h2>Projects</h2>
      <div className="project-filter">
        <button onClick={() => setFilter('all')} className={filter === 'all' ? 'active' : ''}>All</button>
        <button onClick={() => setFilter('web')} className={filter === 'web' ? 'active' : ''}>Web</button>
        <button onClick={() => setFilter('ml')} className={filter === 'ml' ? 'active' : ''}>Machine Learning</button>
        <button onClick={() => setFilter('mob')} className={filter === 'mob' ? 'active' : ''}>Mobile</button>
      </div>
      <div className="project-list">
        {currentProjects.map((project, index) => (
          <div key={index} className={`project ${project.category}`}>
            <div className="project-text">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <p><strong>Tech Stack:</strong> {project.techStack.join(', ')}</p>
              {/* <a className='textColor' href={project.link} target="_blank" rel="noopener noreferrer">View Project</a> */}
            </div>
            <img src={project.img} alt={project.title} />
          </div>
        ))}
      </div>
      <Pagination
        projectsPerPage={projectsPerPage}
        totalProjects={filteredProjects.length}
        paginate={paginate}
        currentPage={currentPage}
      />
    </section>
  );
}

function Pagination({ projectsPerPage, totalProjects, paginate, currentPage }) {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalProjects / projectsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className="pagination">
      {pageNumbers.map(number => (
        <button 
          key={number} 
          onClick={() => paginate(number)} 
          className={`page-btn ${currentPage === number ? 'active' : ''}`}
        >
          {number}
        </button>
      ))}
    </nav>
  );
}

export default Projects;
